import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import { useTranslation } from 'react-i18next';
import CademiIcon from '../icons/Cademi';
import MundCademi from '../icons/MundCademi';

export default function Cademi() {
  const { t } = useTranslation('integration');

  return (
    <IntegrationTable
      integrationKey="cademi"
      title="Cademi"
      main_icon={<MundCademi />}
      icon={<CademiIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        payment_methods: ['credit_card', 'pix', 'bank_slip'],
        active_statuses: ['paid', 'refunded'],
      }}
      fieldLabels={{
        access_token: t('cademi.access_token'),
        placeholder_access_token: t('cademi.access_token_placeholder'),
        postback_url: t('cademi.postback_url'),
        placeholder_postback_url: t('cademi.postback_url_placeholder'),
      }}
    />
  );
}
